import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { CreateNoteFormValue } from "../analysis-notes.service";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";


@Component({
    selector: "wfdss-rte-create-note",
    templateUrl: "./rte-create-note.component.html",
    styleUrls: ["./rte-create-note.component.scss"],
    standalone: false
})
export class RTECreateNoteComponent implements OnInit, OnDestroy {
    @Input() resetForm$: Observable<void>
    protected _noteType: {type: string, disabled: boolean}[];
    @Input() label: string = "label";
    @Input() set noteType(value:{type: string, disabled: boolean}[]){
      this._noteType = value
    if(this._noteType?.length === 1){
        this.fg.get('type').setValue(this._noteType[0].type)
        this.fg.updateValueAndValidity()
        this.fg.get('type').disable()
      }
    };
    get noteType(){
      return this._noteType
    }
    @Input() saveText: string = "Save"
    @Output() save = new EventEmitter<CreateNoteFormValue>();
    @Output() cancel = new EventEmitter()
    fg = new FormGroup({
        type: new FormControl(null, Validators.required),
        title: new FormControl(null, [Validators.required, Validators.maxLength(100)]),
        content: new FormControl(null, Validators.required),
    });
    disableSave = false;
    stopAutocomplete = new Subject<void>();
    readonly onDestroy = new Subject<void>();
    @Input() _noteFormSubj: BehaviorSubject<FormGroup>; // Applicable only for Status Note for changing status under 'Statusing' section
    @Input() hasOutSideSaveBtn = false;

    constructor() {}
    ngOnInit(): void {
        this.resetForm$.subscribe(()=>{
            this.fg.reset()
            this.fg.updateValueAndValidity()
        })
        this.fg.statusChanges.pipe(takeUntil(this.stopAutocomplete.asObservable()))
        .subscribe((status) => {
            if(this.fg.touched){
                if (status === "INVALID") {
                    this.disableSave =true
                } else if (status === "VALID") {
                    this.disableSave = false;
                }
            } else {
                this.disableSave = false
            }
        });

        this.fg
            .get("content")
            .valueChanges.pipe(
              takeUntil(this.stopAutocomplete.asObservable()))
            .subscribe((cval) => {
                if(!this.fg.get('title').touched && cval){
                  this.fg.get("title").setValue(this.getRichTextEditorTextFromBody(cval));
                }
                if (this._noteFormSubj) {
                    this._noteFormSubj.next(this.fg);
                }
            });
    }

    onSave() {
        if (!this.fg.valid) {
            this.fg.markAllAsTouched();
        } else {
            let saveNoteObject = this.fg.getRawValue();
            this.save.emit(saveNoteObject);
        }
    }
    onCancel() {
      this.fg.reset({
        type: "",
        content: "",
        title: "",
      })
      this.noteType = this.noteType
      this.cancel.emit()
    }

    getRichTextEditorTextFromBody(prop: string, isDataUsedForCSV?: boolean) {
        const parser = new DOMParser();
        const rteContent = parser.parseFromString(prop, "text/html");
        const plainText = rteContent.body.textContent ? rteContent.body.textContent : "";
        if (isDataUsedForCSV) {
            return plainText ? plainText : "";
        } else {
            return plainText ? plainText.substring(0, 50) : "";
        }
    }

    ngOnDestroy(): void {
        this.onDestroy.next();
        this.onDestroy.complete();
        this.onDestroy.unsubscribe();
        this.stopAutocomplete.next();
        this.stopAutocomplete.complete();
        this.stopAutocomplete.unsubscribe();
    }
}
